<template>
  <item-form />
</template>

<script>

import ItemForm from '@/views/Projects/ItemForm.vue'

export default {
  name: 'Edit',
  components: {
    ItemForm,
  },
}
</script>
